(function () {
  document.querySelectorAll('[data-collection-product-tabs]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-collection-product-tab]');
    const panels = root.querySelectorAll('[data-collection-product-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-collection-product-tab');

        buttons.forEach((item) => item.classList.remove('active'));
        panels.forEach((panel) => panel.classList.remove('active'));

        button.classList.add('active');
        root.querySelector(`[data-collection-product-panel="${target}"]`)?.classList.add('active');
      });
    });

    // Card click to navigate
    root.querySelectorAll('.collection-tab-product-card').forEach((card) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        const url = card.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
    });
  });
})();
